import { TemplateEditViews } from '../common';
import { useQueryParamContext } from '../context/QueryParamContext';
import { EmbeddedContext } from './context/EmbeddedContext';
import PreviewWithData from './preview/PreviewWithData';
import { Settings } from './settings/Settings';

const renderView = (view: string) => {
  switch (view) {
    case TemplateEditViews.preview:
      return <PreviewWithData />;
    default:
      return <Settings />;
  }
};

export const EditEmbedded = () => {
  const { view } = useQueryParamContext();

  return <EmbeddedContext>{renderView(view)}</EmbeddedContext>;
};
